// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

export const FLEET_TRACING_BASE_ROUTE = '/fleet-tracing'

export const BaseFleetTracingAreaRoutes = {
  route: FLEET_TRACING_BASE_ROUTE,
  Vehicle: {
    route: '/vehicle',
  },
}

export const FleetTracingAreaRoutes = transformRoutes(
  BaseFleetTracingAreaRoutes,
)
